import React, {useCallback, useMemo, useState} from "react"
import {Grid, Stack, Tab, Tabs, Typography} from "@mui/material"
import Questionaire from "./Questionaire"
import TabContent from "../../container/ContainerTab/TabContent"
import PrimaryButtonWidget from "../buttons/PrimaryButtonWidget"
import GhostButtonWidget from "../buttons/GhostbuttonWidget"

export const widgetFragenkatalogTabsPrototype = [
    {
        key: "lane",
        type: "SELECTTREE",
        label: "Fragebogen",
        size: 6,
        options: "questionList",
    },
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 6,
        options: [
            {value: "DEFAULT", label: "Default"},
            {value: "BORDERLESS", label: "Borderless"},
        ],
    },
    {
        key: "actionFirstBack",
        type: "STRING",
        label: "Aktion zurück (erste)",
        size: 3,
    },
    {
        key: "actionLastNext",
        type: "STRING",
        label: "Aktion weiter (letzte)",
        size: 3,
    },
    {
        key: "disableNextPrevButtons",
        type: "CHECKBOX",
        label: "Weiter/Zurück Buttons ausblenden",
        size: 6,
    },
    {
        key: "titleLastNext",
        type: "STRING",
        label: "Aktion weiter (letzte) titel",
        size: 6,
    },
]

const WEITER_TITLE = "weiter"

const WidgetFragenkatalogTabs = ({
    widget,
    value,
    getDataFromPointer,
    updateData,
    triggerAction,
    contextArea,
}) => {
    const lane = value ?? widget?.lane?.origin
    const variant = widget?.variant ?? "DEFAULT"
    const {
        actionFirstBack,
        actionLastNext,
        titleLastNext,
        disableNextPrevButtons = false,
    } = widget ?? {}

    const sections = lane?.children ?? []
    const [activeTab, setActiveTab] = useState(0)
    const onTabClick = (event, newValue) => setActiveTab(newValue)

    const isLastEl = useMemo(
        () => sections.length === activeTab + 1,
        [activeTab, sections.length],
    )

    const hasNext = useMemo(
        () => Boolean(actionLastNext) || !isLastEl,
        [isLastEl, actionLastNext],
    )

    const hasBack = useMemo(
        () => Boolean(actionFirstBack) || activeTab !== 0,
        [activeTab, actionFirstBack],
    )

    const onClickBack = useCallback(() => {
        return actionFirstBack && activeTab === 0
            ? triggerAction(actionFirstBack)
            : setActiveTab((prev) => prev - 1)
    }, [triggerAction, actionFirstBack, activeTab])

    const onClickNext = useCallback(() => {
        return actionLastNext && isLastEl
            ? triggerAction(actionLastNext)
            : setActiveTab((prev) => prev + 1)
    }, [actionLastNext, triggerAction, isLastEl])

    const getNextTitle = useMemo(
        () => (isLastEl ? titleLastNext || WEITER_TITLE : WEITER_TITLE),
        [titleLastNext, isLastEl],
    )

    return (
        <Stack spacing={6}>
            {variant === "DEFAULT" && lane?.longname && (
                <Typography
                    variant="h2"
                    component="h2">
                    {lane.longname}
                </Typography>
            )}
            <Tabs
                value={activeTab}
                onChange={onTabClick}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile>
                {sections.map((section, key) => (
                    <Tab
                        label={section.longname || section.label}
                        key={`tab-${section.id}`}
                        id={`tab-${key}`}
                    />
                ))}
            </Tabs>
            {sections.map((section, key) => (
                <TabContent
                    key={section.id}
                    value={activeTab}
                    index={key}>
                    <Questionaire
                        questionaire={section}
                        getDataFromPointer={getDataFromPointer}
                        updateData={updateData}
                        triggerAction={triggerAction}
                        contextArea={contextArea}
                        variant={variant}
                    />
                </TabContent>
            ))}
            {!disableNextPrevButtons && (
                <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end">
                    {hasBack && (
                        <Grid>
                            <GhostButtonWidget
                                widget={{
                                    text: "zurück",
                                    onClick: onClickBack,
                                }}
                            />
                        </Grid>
                    )}
                    {hasNext && (
                        <Grid>
                            <PrimaryButtonWidget
                                widget={{
                                    text: getNextTitle,
                                    onClick: onClickNext,
                                }}
                            />
                        </Grid>
                    )}
                </Grid>
            )}
        </Stack>
    )
}

export default WidgetFragenkatalogTabs
